import '../../../../scss/user-modal.scss';

import Vue from 'vue';
import { registerPaymentModalHelper } from '../modal/register_payment_flow/register-payment-modal-helper';
import { projectHelper } from '../../misc/project-helper';
import {getCookieValue, isCookieSet, setCookie} from '../../../qaamgo/helper/cookie';
import UserNotifications from './UserNotifications.vue';
import { eventBus } from '../../../lib/event-bus/event-bus';
import { USER_NOTIFICATION_SHOW, USER_NOTIFICATIONS } from './user-notifications';
import { userManager } from '../user-manager';
import { testIsNull } from '../../../lib/test-and-assert/test-base';
import { User } from '../user';

async function initializeUserNotifications() {
    const [user] = await Promise.all([
        userManager.getUser(),
        import(
            /* webpackMode: "lazy-once" */
            `../../../entrypoints/translations/sat-translations.js`
        ),
    ]);

    new Vue({
        el: '#userNotifications',
        name: 'UserNotificationsRoot',
        components: { UserNotifications },
        render(h) {
            return h(UserNotifications);
        },
    });

    function handleUnconfirmedUser() {
        if (testIsNull(user) || user.hasRole(User.ROLE_ANONYMOUS) || user.isEnabled()) {
            return;
        }

        eventBus.emit(USER_NOTIFICATION_SHOW, {
            name: USER_NOTIFICATIONS.UNCONFIRMED_USER,
            data: user,
        });
    }

    handleUnconfirmedUser();

    function handleEducationalUser() {
        const shouldHideEduClaimBanner =
            projectHelper.isApi2Convert() || getCookieValue('user-edu-claim-banner-dismiss');

        if (
            shouldHideEduClaimBanner ||
            !user.isEnabled() ||
            !user.hasRole(User.ROLE_USER_ELIGIBLE_FOR_EDUCATIONAL) ||
            user.hasRole(User.ROLE_USER_EDUCATIONAL)
        ) {
            return;
        }

        if (user.hasRole(User.ROLE_USER_NEEDS_VERIFICATION_FOR_EDUCATIONAL)) {
            if (!isCookieSet('user-edu-renew-banner-dismiss')) {
                eventBus.emit('EducationExpiredModal', {
                    user
                });
            }

            return;
        }
        eventBus.emit(USER_NOTIFICATION_SHOW, {
            name: USER_NOTIFICATIONS.ELIGIBLE_FOR_EDUCATIONAL,
            data: user,
        });
    }

    handleEducationalUser();
}

initializeUserNotifications();

const salebannerOpenModalButton = document.getElementById('saleBannerOpenModalButton');

if (salebannerOpenModalButton) {
    salebannerOpenModalButton.addEventListener('click', () => {
        registerPaymentModalHelper.openForPricingPremium({
            size: projectHelper.isOnlineConvert() ? '200' : null,
            billing: 'annual_%currency%_%version%_sale_cyberweek',
            plan: 'individual',
        });
    });
}

const saleBannerCloseButton = document.getElementById('saleBannerClose');

if (saleBannerCloseButton) {
    saleBannerCloseButton.addEventListener('click', () => {
        //1 month
        var maxAge = 3888000;
        setCookie('qg_sale_dismiss', true, maxAge);
        document.getElementById('saleBanner').classList.add('hidden');
    });
}
